<template>
    <v-container>
      <v-row justify="center" align="center">
        <v-col cols="12" class="text-center">
          <h1>這是一個空的網頁</h1>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    name: 'Application',
  };
  </script>
  
  <style scoped>
  /* 這裡可以添加任何特定的樣式 */
  </style>
  